import { Link } from 'react-router'

export const MarkdownLink = ({ href, title = '', id, children }: {href: string, title?: string, id?: string, children?: React.ReactNode}) => <Link to={href} title={title} id={id}>{children}</Link>
